import React, { useState } from "react";
import "./Footer.css"; // Pour le style du modal

// Composant pour afficher les Mentions Légales dans un modal
const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Fonction pour ouvrir et fermer le modal
  const toggleModal = () => setIsOpen(!isOpen);

  return (

<footer className="footer">
    
    <p><a onClick={toggleModal} className="legal-button">Mentions Légales</a> &copy; {new Date().getFullYear()} TRH Menuiserie</p>


    
    <div >
      {/* Lien pour ouvrir le modal */} 
      
      {/* Modal */}
      {isOpen && (
        <div id="MentionsLegales" onClick={toggleModal}>

        <div className="modal-overlay">
          <div className="modal-content">
            <span className="close-button" onClick={toggleModal}>&times;</span>
            <h2>Mentions Légales</h2>
            <p><strong>Hébergement :</strong><br />Nom de l'hébergeur : Vercel<br />Site web : vercel.com</p>
            <p><strong>Responsabilité :</strong><br />TRH Menuiserie décline toute responsabilité quant à l’utilisation des informations fournies sur le site. Les informations sont fournies à titre indicatif et peuvent évoluer sans préavis.</p>
            <p><strong>Crédits :</strong><br />Réalisation : <a href="mailto:jonathan.turchi@gmail.com">Jonathan TURCHI</a></p>
          </div>
        </div>

        </div>
      )}
    </div>

    </footer>
  );
};

export default Footer;
